export default "__VITE_ASSET__CKfR7eLL__"